"use client";
import React, { Suspense, lazy, useEffect } from "react";
import { Footer } from "@/components/Footer";
import HomePageBanner from "@/components/common/HomePageBanner";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import { useRouter } from "next/navigation";
import { useInstructorData } from "@/hooks/useInstructorAuth";
import { useAuthSession } from "@/hooks/useAuthSession";

const TestimonialSection = lazy(
    () => import("@/components/common/TestimonialSection")
);
const WhyChooseUsSection = lazy(
    () => import("@/components/common/WhyChooseUsSection")
);
const JoinCommunitySection = lazy(
    () => import("@/components/common/JoinCommunity")
);
const ExpertTabsSection = lazy(
    () => import("@/components/common/ExpertTabsSection")
);
const ExpertInstructorSection = lazy(
    () => import("@/components/common/ExpertInstructorSection")
);
const HomeBlogSection = lazy(
    () => import("@/components/common/HomeBlogSection")
);

const SectionLoader = () => (
    <LoadingSpinner fullScreen={false} showText={false} className="py-8" />
);

export default function HomeClient() {
    const router = useRouter();
    const { user } = useAuthSession();

    // Only check instructor auth if user has instructor role — avoids
    // unnecessary /api/auth/check-instructor calls for students & guests
    const isInstructorRole = user?.role === "INSTRUCTOR";
    const { isAuthenticated, instructor, isLoading } = useInstructorData(isInstructorRole);

    useEffect(() => {
        if (isInstructorRole && !isLoading && isAuthenticated && instructor) {
            router.push("/instructors/dashboard");
        }
    }, [isInstructorRole, isAuthenticated, instructor, isLoading, router]);

    return (
        <div> 
            <HomePageBanner />
            
            <Suspense fallback={<SectionLoader />}>
                <ExpertTabsSection bgColor="bg-white" />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <HomeBlogSection bgColor="bg-gray-50" />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <ExpertInstructorSection bgColor="bg-white" />
            </Suspense>
 
            <Suspense fallback={<SectionLoader />}>
                <WhyChooseUsSection />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <TestimonialSection />
            </Suspense>

            <Suspense fallback={<SectionLoader />}>
                <JoinCommunitySection />
            </Suspense>

            <Footer />
        </div>
    );
}
